import styled from 'styled-components'

export const Wrapper = styled.div`
  > svg {
    width: 16px;
    color: #4c4c4c;
    padding: 8px;
    border-radius: 8px;
    background-color: #f0f0f0;
    margin-right: 16px;
    float: left;
    cursor: pointer;
    &:hover {
      color: #213f68;
      background-color: #9ecffa40;
    }
  }
  > span {
    font-size: 20px;
    font-weight: 700;
    color: #213f68;
  }
`

export const Alert = styled.div`
  font-size: 14px;
  padding: 8px 16px;
  margin-top: 24px;
  color: #363636;
  background-color: #e7f3fe;
  border: 1px solid #b6dbfb;
  border-radius: 8px;
  svg {
    color: #213f68;
    margin-right: 12px;
  }
  svg + svg {
    float: right;
    cursor: pointer;
    color: #757575;
    margin-top: 4px;
    margin-right: 0;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const WarningAlert = styled(Alert)`
  background-color: #fff8e6;
  border: 1px solid #ffe58f;
  svg:first-child {
    color: #d48806;
  }
`
